import React from 'react';
import ReactDOM from 'react-dom';

// PROPS:
  // options: Options passed to google Autocomplete 
  // onPlaceChanged: Event fired when user selects a place result from the dropdown
  // children: Single child of type input, for the Autocomplete to attach to.

// METHODS: Attach a ref to this component to access
  // getPlace: Returns the user selected place

export default class AutoComplete extends React.Component {
  state = {
    autoComplete: null
  }

  componentDidMount() {
    const element = ReactDOM.findDOMNode(this);
    const autoComplete = new window.google.maps.places.Autocomplete(
      element.querySelector("input") || element,
      {
        fields: ['address_components', 'formatted_address', 'geometry.location', 'types'],
        componentRestrictions: { country: 'us' },
        ...this.props.options
      }
    );
    autoComplete.addListener("place_changed", this.props.onPlaceChanged);
    this.setState({
      autoComplete
    });
  }

  getPlace() {
    return this.state.autoComplete.getPlace();
  }

  render() {
    return React.Children.only(this.props.children);
  }
};